var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('div',{staticClass:"floatButton",on:{"click":function($event){return _vm.pageBack()}}},[_vm._v("\n    返回\n")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }